import { ReactNode, useEffect } from 'react';

import { useSubscription } from 'react-stomp-hooks';

import { useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useProjectTreeStore } from 'store/projectContract.store';
import { useRiskRegisterStore } from 'store/riskRegister.store';

export const useRiskRegisterTabsLogic = () => {
    const { update } = useRiskRegisterStore();
    const activeTab = useRiskRegisterStore((state) => state.activeTab);
    const runQsra = useRiskRegisterStore((state) => state.runQsra);
    const { handleSnackBar } = useCustomSnackBar();
    const { email } = useUserHook();
    const { project, contract } = useProjectTreeStore();

    const tabsList: { value: 'table' | 'chart'; label: ReactNode; disabled?: boolean; tooltip?: string }[] = [
        {
            value: 'table',
            label: 'Risk Register',
        },
        {
            value: 'chart',
            label: 'QSRA Distribution Chart',
            disabled: !runQsra,
            tooltip: "To generate Distribution Chart select Risk items and click 'Run QSRA'",
        },
    ];

    useSubscription(email ? [`/topic/${email}.notifications.push`] : [], (response) => {
        const { type, message } = JSON.parse(response.body) as {
            type: string;
            message: {
                key: string; //key from QSRA
                value: {
                    type: 'error' | 'success' | 'warning' | 'info';
                    text: string;
                };
            };
        };

        const t = setTimeout(() => {
            const qsraResponseKey = useRiskRegisterStore.getState().qsraResponseKey;
            if (type === 'QSRA' && qsraResponseKey === message.key) {
                if (message.value.type === 'success') {
                    update({
                        showModal: false,
                        runQsra: !runQsra ? 1 : runQsra + 1,
                        isRunningQsra: false,
                        activeTab: 'chart',
                    });
                } else {
                    update({
                        showModal: false,
                        isRunningQsra: false,
                        runQsra: null,
                    });
                }
                handleSnackBar(message.value.text, message.value.type);
            }
        }, 1000);

        return () => {
            clearTimeout(t);
        };
    });

    useEffect(() => {
        if (project) {
            update({
                numOfIterations: 10,
                riskIds: [],
                taskVersionHashCode: null,
                taskVersionLabel: null,
                isRunningQsra: false,
                showModal: false,
                period: 'WEEK',
                activeTab: 'table',
                runQsra: null,
                qsraResponseKey: null,
            });
        }
    }, [project, contract]);

    const setActiveTab = (value) => update({ activeTab: value });

    return {
        logic: {
            activeTab,
            tabsList,
            setActiveTab,
        },
    };
};
